/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Sortby_Viewabledate2Inputs */

const id_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Dapat Dilihat`)
};

const ms_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Boleh Dilihat`)
};

const da_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synlighedsdato`)
};

const de_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbarkeitsdatum`)
};

const en_us2_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewable Date`)
};

const es_es2_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha visible`)
};

const es_mx2_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha visible`)
};

const fil_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa na Maaaring Makita`)
};

const fr_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de visibilité`)
};

const it_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data visualizzabile`)
};

const hu_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megtekinthető dátum`)
};

const nl_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zichtbare datum`)
};

const no_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synlig dato`)
};

const pl_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data widoczności`)
};

const pt_br2_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data visível`)
};

const pt_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data visível`)
};

const ro_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data vizibilă`)
};

const fi_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näkyvä päivä`)
};

const sv_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synligt datum`)
};

const vi_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hiển thị`)
};

const tr_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görüntülenme Tarihi`)
};

const cs_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum zobrazení`)
};

const bg_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на видимост`)
};

const ru_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата отображения`)
};

const uk_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата показу`)
};

const ar_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الظهور`)
};

const hi_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दृश्य तारीख़`)
};

const th_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่มองเห็น`)
};

const ja_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示可能日`)
};

const zh_cn2_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可见日期`)
};

const zh_hant1_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可見日期`)
};

const ko_tags_sortby_viewabledate2 = /** @type {(inputs: Tags_Sortby_Viewabledate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표시일`)
};

/**
* | output |
* | --- |
* | "Viewable Date" |
*
* @param {Tags_Sortby_Viewabledate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_sortby_viewabledate2 = /** @type {((inputs?: Tags_Sortby_Viewabledate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Sortby_Viewabledate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_sortby_viewabledate2(inputs)
	if (locale === "ms") return ms_tags_sortby_viewabledate2(inputs)
	if (locale === "da") return da_tags_sortby_viewabledate2(inputs)
	if (locale === "de") return de_tags_sortby_viewabledate2(inputs)
	if (locale === "en-US") return en_us2_tags_sortby_viewabledate2(inputs)
	if (locale === "es-ES") return es_es2_tags_sortby_viewabledate2(inputs)
	if (locale === "es-MX") return es_mx2_tags_sortby_viewabledate2(inputs)
	if (locale === "fil") return fil_tags_sortby_viewabledate2(inputs)
	if (locale === "fr") return fr_tags_sortby_viewabledate2(inputs)
	if (locale === "it") return it_tags_sortby_viewabledate2(inputs)
	if (locale === "hu") return hu_tags_sortby_viewabledate2(inputs)
	if (locale === "nl") return nl_tags_sortby_viewabledate2(inputs)
	if (locale === "no") return no_tags_sortby_viewabledate2(inputs)
	if (locale === "pl") return pl_tags_sortby_viewabledate2(inputs)
	if (locale === "pt-BR") return pt_br2_tags_sortby_viewabledate2(inputs)
	if (locale === "pt") return pt_tags_sortby_viewabledate2(inputs)
	if (locale === "ro") return ro_tags_sortby_viewabledate2(inputs)
	if (locale === "fi") return fi_tags_sortby_viewabledate2(inputs)
	if (locale === "sv") return sv_tags_sortby_viewabledate2(inputs)
	if (locale === "vi") return vi_tags_sortby_viewabledate2(inputs)
	if (locale === "tr") return tr_tags_sortby_viewabledate2(inputs)
	if (locale === "cs") return cs_tags_sortby_viewabledate2(inputs)
	if (locale === "bg") return bg_tags_sortby_viewabledate2(inputs)
	if (locale === "ru") return ru_tags_sortby_viewabledate2(inputs)
	if (locale === "uk") return uk_tags_sortby_viewabledate2(inputs)
	if (locale === "ar") return ar_tags_sortby_viewabledate2(inputs)
	if (locale === "hi") return hi_tags_sortby_viewabledate2(inputs)
	if (locale === "th") return th_tags_sortby_viewabledate2(inputs)
	if (locale === "ja") return ja_tags_sortby_viewabledate2(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_sortby_viewabledate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_sortby_viewabledate2(inputs)
	return ko_tags_sortby_viewabledate2(inputs)
});
export { tags_sortby_viewabledate2 as "tags.sortBy.viewableDate" }